export const FILTERABLE_SEARCH_BAR_SET_LIST = 'FILTERABLE_SEARCH_BAR_SET_LIST'
export const setFilterableSearchBarList = list => ({ type: FILTERABLE_SEARCH_BAR_SET_LIST, list })
